import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';
import { Applicants } from '@/api';

export type State = {
  termsOfServiceVersion: number;
  privacyPolicyVersion: number;
  agreedTermsOfService: boolean;
};

function createState(): State {
  const state: State = {} as State;
  clearState(state);
  return state;
}

function clearState(state: State): void {
  state.termsOfServiceVersion = 0;
  state.privacyPolicyVersion = 0;
  state.agreedTermsOfService = false;
}

export const getters: GetterTree<State, RootState> = {
  termsOfServiceVersion: (state: State): number => state.termsOfServiceVersion,
  privacyPolicyVersion: (state: State): number => state.privacyPolicyVersion,
  agreedTermsOfService: (state: State): boolean => state.agreedTermsOfService
};

export const mutations: MutationTree<State> = {
  storeAgreementVersion(
    state: State,
    payload: {
      termsOfServiceVersion: number;
      privacyPolicyVersion: number;
    }
  ): void {
    state.termsOfServiceVersion = payload.termsOfServiceVersion;
    state.privacyPolicyVersion = payload.privacyPolicyVersion;
  },

  storeAgreedTermsOfService(state: State, payload: boolean): void {
    state.agreedTermsOfService = payload;
  },

  clearState(state: State) {
    clearState(state);
  }
};

export const actions: ActionTree<State, RootState> = {
  clearState(context: ActionContext<State, RootState>): void {
    context.commit('clearState');
  },

  async storeAgreementVersion(context: ActionContext<State, RootState>, payload: number): Promise<void> {
    const response = await Applicants.fetchAgreements(payload);
    context.commit('storeAgreementVersion', {
      termsOfServiceVersion: response.data.termsOfServiceVersion,
      privacyPolicyVersion: response.data.privacyPolicyVersion
    });
  },

  async storeIsAgree(context: ActionContext<State, RootState>, payload: number): Promise<void> {
    await Applicants.fetchAgreementsAgreed(payload, {
      termsOfServiceVersion: context.state.termsOfServiceVersion,
      privacyPolicyVersion: context.state.privacyPolicyVersion
    });
    context.commit('storeAgreedTermsOfService', true);
  }
};

export const terms: Module<State, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};
